import { css } from 'styled-components';
import { spacing } from '../spacing/spacing';
import { InputTags } from './class-name-tags';
const inputStyles = css `
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  padding: ${spacing.spacing8};

  &.error {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &.compact {
    padding: ${spacing.spacing2} ${spacing.spacing4};
  }
`;
export const commonTheme = {
    base: css `
    position: relative;
    display: inline-flex;

    ::after {
      border-bottom: 2px solid;
      border-bottom-color: transparent;
      left: 0;
      bottom: 0;
      content: '';
      position: absolute;
      right: 0;
    }

    .${InputTags.input} {
      ${inputStyles}
    }

    &.start-icon {
      .${InputTags.input} {
        padding-left: ${spacing.spacing32};
      }
    }

    &.end-icon {
      .${InputTags.input} {
        padding-right: ${spacing.spacing32};
      }
    }

    .${InputTags.iconContainer} {
      &.start-icon {
        svg {
          left: ${spacing.spacing8};
        }
      }

      &.end-icon {
        svg {
          right: ${spacing.spacing8};
        }
      }
    }
  `,
};
//# sourceMappingURL=common-theme.js.map